import './Quote.css';
import supabase from '../supabase';
import { useState } from 'react';
function Quote({ quote, setQuotes }) {
	const [isUpdating, setIsUpdating] = useState(false);
	async function handleLike(info) {
		setIsUpdating(true);
		const { data: updatedQuote, error } = await supabase
			.from('quotes')
			.update({ [info]: quote[info] + 1 })
			.eq('id', quote.id)
			.select();
		setIsUpdating(false);
		if (!error)
			setQuotes((quotes) =>
				quotes.map((q) => (q.id === quote.id ? updatedQuote[0] : q))
			);
	}
	return (
		<li className='quote'>
			<p>{quote.text}</p>
			<span className='quote-author'>
				<strong> {quote.author} </strong>
			</span>
			<div className='wrapper'>
				<span className='quote-category'>#{quote.category}</span>
				<a
					className='quote-source'
					href={quote.source}
					target='_blank'
					rel='noreferrer'>
					View Source
				</a>

				<div className='like-buttons'>
					<button
						onClick={() => handleLike('like')}
						disabled={isUpdating}>
						👍 {quote.like}
					</button>
					<button onClick={() => handleLike('dislike')}>
						👎 {quote.dislike}
					</button>
				</div>
			</div>
		</li>
	);
}
export default Quote;
